const paginationResultsPerPage = {
  search: 20,
  searchCommunities: 12,
  searchMembers: 12,
};

export default paginationResultsPerPage;
